import { GameBasketballPosition, WorkHand } from '../models/basketball-profile';
import { GameVolleyballPosition, VolleyballWorkHand } from '../models/volleyball-profile';
import { GameHockeyPosition } from '../models/hockey-profile';
import { FootballWorkFoot, GameFootballPosition } from '../models/football-profile';
import { GameHandballPosition } from '../models/handball-profile';
import { GameRugbyPosition } from '../models/rugby-profile';
import { GameWaterpoloPosition, WaterpoloWorkHand } from '../models/waterpolo-profile';
import { Locales } from './locales';
import { WrestballWorkHand } from '../models/wrestball-profile';

export const GameBasketballPositionLocalization = {
  [Locales.ru]: {
    [GameBasketballPosition.point_guard]: 'Разыгрывающий защитник',
    [GameBasketballPosition.shooting_guard]: 'Атакующий защитник',
    [GameBasketballPosition.small_forward]: 'Легкий форвард',
    [GameBasketballPosition.power_forward]: 'Мощный форвард',
    [GameBasketballPosition.center]: 'Центровой',
  },
  [Locales.en]: {
    [GameBasketballPosition.point_guard]: 'Point guard',
    [GameBasketballPosition.shooting_guard]: 'Shooting guard',
    [GameBasketballPosition.small_forward]: 'Small forward',
    [GameBasketballPosition.power_forward]: 'Power forward',
    [GameBasketballPosition.center]: 'Center',
  }
};

export const GameBasketballPositionShortLocalization = {
  [Locales.ru]: {
    [GameBasketballPosition.point_guard]: 'PG',
    [GameBasketballPosition.shooting_guard]: 'SG',
    [GameBasketballPosition.small_forward]: 'SF',
    [GameBasketballPosition.power_forward]: 'PF',
    [GameBasketballPosition.center]: 'C',
  },
  [Locales.en]: {
    [GameBasketballPosition.point_guard]: 'PG',
    [GameBasketballPosition.shooting_guard]: 'SG',
    [GameBasketballPosition.small_forward]: 'SF',
    [GameBasketballPosition.power_forward]: 'PF',
    [GameBasketballPosition.center]: 'C',
  }
};

export const WorkHandLocalization = {
  [Locales.ru]: {
    [WorkHand.left]: 'Левая',
    [WorkHand.right]: 'Правая',
  },
  [Locales.en]: {
    [WorkHand.left]: 'Left',
    [WorkHand.right]: 'Right',
  }
};

export const HockeyWorkHandLocalization = {
  [Locales.ru]: {
    [WorkHand.left]: 'Левый',
    [WorkHand.right]: 'Правый'
  },
  [Locales.en]: {
    [WorkHand.left]: 'Left',
    [WorkHand.right]: 'Right',
  }
};

export const GameVolleyballPositionLocalization = {
  [Locales.ru]: {
    [GameVolleyballPosition.setter]: 'Связующий',
    [GameVolleyballPosition.libero]: 'Либеро',
    [GameVolleyballPosition.middle_player]: 'Центральный блокирующий',
    [GameVolleyballPosition.receiver_attacker]: 'Доигровщик',
    [GameVolleyballPosition.dioganal]: 'Диагональный',
  },
  [Locales.en]: {
    [GameVolleyballPosition.setter]: 'Setter',
    [GameVolleyballPosition.libero]: 'Libero',
    [GameVolleyballPosition.middle_player]: 'Middle blocker',
    [GameVolleyballPosition.receiver_attacker]: 'Outside hitter',
    [GameVolleyballPosition.dioganal]: 'Diagonal',
  }
};

export const GameVolleyballPositionShortLocalization = {
  [Locales.ru]: {
    [GameVolleyballPosition.setter]: 'S',
    [GameVolleyballPosition.libero]: 'L',
    [GameVolleyballPosition.middle_player]: 'MP',
    [GameVolleyballPosition.receiver_attacker]: 'RA',
    [GameVolleyballPosition.dioganal]: 'D',
  },
  [Locales.en]: {
    [GameVolleyballPosition.setter]: 'S',
    [GameVolleyballPosition.libero]: 'L',
    [GameVolleyballPosition.middle_player]: 'MP',
    [GameVolleyballPosition.receiver_attacker]: 'RA',
    [GameVolleyballPosition.dioganal]: 'D',
  }
};

export const GameVolleyballPositionShortRuLocalization = {
  [Locales.ru]: {
    [GameVolleyballPosition.setter]: 'связ.',
    [GameVolleyballPosition.libero]: 'либеро',
    [GameVolleyballPosition.middle_player]: 'блок.',
    [GameVolleyballPosition.receiver_attacker]: 'доигр.',
    [GameVolleyballPosition.dioganal]: 'диаг.',
  },
  [Locales.en]: {
    [GameVolleyballPosition.setter]: 'Setter',
    [GameVolleyballPosition.libero]: 'Libero',
    [GameVolleyballPosition.middle_player]: 'Middle blocker',
    [GameVolleyballPosition.receiver_attacker]: 'Outside hitter',
    [GameVolleyballPosition.dioganal]: 'Diagonal',
  }
};

export const VolleyballWorkHandLocalization = {
  [Locales.ru]: {
    [VolleyballWorkHand.left]: 'Левая',
    [VolleyballWorkHand.right]: 'Правая'
  },
  [Locales.en]: {
    [WorkHand.left]: 'Left',
    [WorkHand.right]: 'Right',
  }
};

export const GameHockeyPositionLocalization = {
  [Locales.ru]: {
    [GameHockeyPosition.goaltender]: 'Вратарь',
    [GameHockeyPosition.defensemen]: 'Защитник',
    [GameHockeyPosition.forward]: 'Нападающий',
  },
  [Locales.en]: {
    [GameHockeyPosition.defensemen]: 'Defender',
    [GameHockeyPosition.forward]: 'Forward',
    [GameHockeyPosition.goaltender]: 'Goalkeeper',
  }
};

export const GameFootballPositionLocalization = {
  [Locales.ru]: {
    [GameFootballPosition.goalkeeper]: 'Вратарь',
    [GameFootballPosition.defensemen]: 'Защитник',
    [GameFootballPosition.midfielder]: 'Полузащитник',
    [GameFootballPosition.forward]: 'Нападающий',
  },
  [Locales.en]: {
    [GameFootballPosition.defensemen]: 'Defender',
    [GameFootballPosition.midfielder]: 'Midfielder',
    [GameFootballPosition.forward]: 'Forward',
    [GameFootballPosition.goalkeeper]: 'Goalkeeper',
  }
};

export const FootballWorkFootLocalization = {
  [Locales.ru]: {
    [FootballWorkFoot.left]: 'Левая',
    [FootballWorkFoot.right]: 'Правая',
    [FootballWorkFoot.both]: 'Обе'
  },
  [Locales.en]: {
    [FootballWorkFoot.left]: 'Left',
    [FootballWorkFoot.right]: 'Right',
    [FootballWorkFoot.both]: 'Both',
  }
};

export const GameHandballPositionLocalization = {
  [Locales.ru]: {
    [GameHandballPosition.goalkeeper]: 'Вратарь',
    [GameHandballPosition.winger]: 'Крайний',
    [GameHandballPosition.pivot]: 'Линейный',
    [GameHandballPosition.centre_back]: 'Центральный',
    [GameHandballPosition.fullback]: 'Полусредний',
  },
  [Locales.en]: {
    [GameHandballPosition.goalkeeper]: 'Goalkeeper',
    [GameHandballPosition.winger]: 'Wing',
    [GameHandballPosition.pivot]: 'Pivot',
    [GameHandballPosition.centre_back]: 'Centre back',
    [GameHandballPosition.fullback]: 'Back',
  }
};

export const GameRugbyPositionLocalization = {
  [Locales.ru]: {
    [GameRugbyPosition.front_line]: 'Надающий первой линии',
    [GameRugbyPosition.second_line]: 'Нападающий второй линии',
    [GameRugbyPosition.back_line]: 'Нападающий задней линии',
    [GameRugbyPosition.halfback]: 'Полузащитник',
    [GameRugbyPosition.three_quarter]: 'Трехчетвертный',
    [GameRugbyPosition.fullback]: 'Замыкающий',
  },
  [Locales.en]: {
    [GameRugbyPosition.front_line]: 'The forward of the first line',
    [GameRugbyPosition.second_line]: 'The forward of the second line',
    [GameRugbyPosition.back_line]: 'The forward of the back line',
    [GameRugbyPosition.halfback]: 'Halfback',
    [GameRugbyPosition.three_quarter]: 'Three quarter',
    [GameRugbyPosition.fullback]: 'Fullback',
  }
};

export const GameWaterpoloPositionLocalization = {
  [Locales.ru]: {
    [GameWaterpoloPosition.defensemen]: 'Защитник',
    [GameWaterpoloPosition.goalkeeper]: 'Вратарь',
    [GameWaterpoloPosition.center_forward]: 'Центральный нападающий',
    [GameWaterpoloPosition.mobile_forward]: 'Подвижный нападающий',
    [GameWaterpoloPosition.winger]: 'Крайний нападающий',
  },
  [Locales.en]: {
    [GameWaterpoloPosition.defensemen]: 'Defender',
    [GameWaterpoloPosition.goalkeeper]: 'Goalkeeper',
    [GameWaterpoloPosition.center_forward]: 'Center forward',
    [GameWaterpoloPosition.mobile_forward]: 'Mobile forward',
    [GameWaterpoloPosition.winger]: 'Winger',
  }
};

export const GameWaterpoloPositionShortRuLocalization = {
  [Locales.ru]: {
    [GameWaterpoloPosition.defensemen]: 'З',
    [GameWaterpoloPosition.goalkeeper]: 'Вр',
    [GameWaterpoloPosition.center_forward]: 'ЦН',
    [GameWaterpoloPosition.mobile_forward]: 'ПН',
    [GameWaterpoloPosition.winger]: 'КН',
  },
  [Locales.en]: {
    [GameWaterpoloPosition.defensemen]: 'D',
    [GameWaterpoloPosition.goalkeeper]: 'G',
    [GameWaterpoloPosition.center_forward]: 'CF',
    [GameWaterpoloPosition.mobile_forward]: 'MF',
    [GameWaterpoloPosition.winger]: 'W',
  }
};

export const WaterpoloWorkHandLocalization = {
  [Locales.ru]: {
    [WaterpoloWorkHand.left]: 'Левая',
    [WaterpoloWorkHand.right]: 'Правая',
  },
  [Locales.en]: {
    [WaterpoloWorkHand.left]: 'Left',
    [WaterpoloWorkHand.right]: 'Right'
  }
};
export const WrestballWorkHandLocalization = {
  [Locales.ru]: {
    [WrestballWorkHand.left]: 'Левая',
    [WrestballWorkHand.right]: 'Правая'
  },
  [Locales.en]: {
    [WrestballWorkHand.left]: 'Left',
    [WrestballWorkHand.right]: 'Right'
  }
};

